import React from 'react';
import { Select } from 'antd';
import { fieldDefaultProps } from 'utils/fieldConfig';
import { localeOptions } from '../LanguagePicker';
import { useTranslation } from 'react-i18next';

export type BannerLangPickerProps = {
  value?: string;
  onChange?: (value: string) => void;
};

const BannerLangPicker: React.FC<BannerLangPickerProps> = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <Select
      {...fieldDefaultProps}
      placeholder={t('auth.signup.languagePreference.placeholder')}
      data-testid="language-select"
      defaultValue={localeOptions[0].key}
      value={value}
      onChange={onChange}
    >
      {localeOptions.map((option) => (
        <Select.Option key={option.key} value={option.key}>
          {option.label}
        </Select.Option>
      ))}
    </Select>
  );
};

export default BannerLangPicker;
